import { Box, Container, Typography } from "@mui/material";
import SectionHero from "./SectionHero";

const MainPage = () => {

    return (<>
        <SectionHero />

        <Container maxWidth='xl'>

            <Box sx={{ mb: 3 }}>
                <Typography component='h3' sx={{
                    fontWeight: 'bold',
                    fontSize: '2.5rem',
                    textAlign: 'center',
                    mb: 2,
                }}>
                </Typography>
            </Box>
        </Container>

    </>);
}

export default MainPage;